import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { aiVisibilityService } from '../../services/aiVisibilityService';
import StatusScreen, { StatusText } from '../../components/StatusScreen';

// /seguimiento/baja?t=<token>, from the link in every follow-up email. It
// asks for a click instead of unsubscribing on load: mail scanners open
// links by themselves and would unsubscribe people without their knowing.
const Unsubscribe = () => {
  const [params] = useSearchParams();
  const token = params.get('t') || '';
  const [state, setState] = useState({ status: 'idle', message: null, businessName: null });

  const handleClick = async () => {
    setState({ status: 'sending', message: null, businessName: null });
    const result = await aiVisibilityService.unsubscribeMonitoring(token);
    setState(
      result.success
        ? { status: 'done', message: null, businessName: result.businessName }
        : { status: 'error', message: result.message, businessName: null }
    );
  };

  if (state.status === 'done') {
    return (
      <StatusScreen kicker="Seguimiento mensual" title="Te has dado de baja">
        <StatusText>
          No te enviaremos más informes mensuales de {state.businessName}. Tus informes anteriores siguen disponibles en
          sus enlaces.
        </StatusText>
        <div className="mt-10">
          <Link to="/" className="font-semibold underline decoration-[var(--lp-lime)] decoration-2 underline-offset-8">
            Volver al inicio
          </Link>
        </div>
      </StatusScreen>
    );
  }

  return (
    <StatusScreen kicker="Seguimiento mensual" title="¿Darte de baja del seguimiento?">
      <StatusText>Dejarás de recibir el informe mensual por email. Puedes volver a activarlo cuando quieras.</StatusText>
      <div className="mt-10">
        <button type="button" className="lp-btn" onClick={handleClick} disabled={!token || state.status === 'sending'}>
          {state.status === 'sending' ? 'Dando de baja…' : 'Darme de baja'}
        </button>
      </div>
      {!token && <StatusText>Falta la referencia en el enlace. Ábrelo tal como te llegó por email.</StatusText>}
      {state.status === 'error' && (
        <p role="alert" className="mt-6 text-sm font-medium text-[var(--lp-alarm)]">
          {state.message}
        </p>
      )}
    </StatusScreen>
  );
};

export default Unsubscribe;
